function subpage() {
	const mainSubpage = document.querySelector('main.subpage');
	if (!mainSubpage) return;

	// Subpage code here...
}
